/**
 *
 * News
 *
 */

import React from "react";
// import PropTypes from 'prop-types';
// import styled from 'styled-components';
//import ChartComparation from './components/ChartComparation';
import ChartDyn from "./componentes/index";
import HomeIcon from "@material-ui/icons/Home";

/* eslint-disable react/prefer-stateless-function */
class News extends React.Component {
  render() {
    return (
      <div className="card">
        <h5 className="card-header">
          {" "}
          <HomeIcon color="primary" /> Estado General (IIM){" "}
        </h5>
        <div className="card-body">
          <ChartDyn />
        </div>
      </div>
    );
  }
}

News.propTypes = {};

export default News;
